/**
 * 公共js，可以将一些方法放到这里
 */
import axios from 'axios'
// import bridge from './bridge'
import router from "@/router"

//  测试环境
// var baseUrl = 'https://test.api.jgzpro.com'

//  正式环境
var baseUrl = process.env.VUE_APP_BASE_API2
// process.env.NODE_ENV == "development" ? 'https://test.api.jgzpro.com' : 'https://api.jgzpro.com'
console.log('环境', process.env, baseUrl)

//  新生产环境
// var baseUrl = 'https://api.jinguozi.net'

var MyCommons = {};

//  创建axios实例
var axiosInstance = axios.create({
	baseURL: baseUrl,
})

// axiosInstance.defaults.headers.common['username'] = window.localStorage.getItem('__username');
// axiosInstance.defaults.headers.common['userRole'] = window.localStorage.getItem('__role');
// debugger
// console.log(router.currentRoute)
// let token = router.currentRoute.query.auth;
// axiosInstance.defaults.headers.common['Authorization'] = token;
axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//动态域名使用
let url = window.location.href;
let scope = ''
//查询ip
if (url.indexOf('jgz') >= 0) {
	scope = 'JGZ'
} else {
	scope = 'JGZ' //XP_DATA
}
axiosInstance.defaults.headers.get['scope'] = scope
//  请求拦截器
// axiosInstance.interceptors.response.use((response) => {
// 	response.headers.common['scope'] = 'JGZ'
// 	return response;
// })

//  请求拦截器
// axiosInstance.interceptors.response.use((response) => {
//     if(response.headers.authorization && response.headers.authorization != window.localStorage.getItem("__token")){
//         window.localStorage.setItem('__token', response.headers.authorization);
//     }
//     return response;
// }, (error)=> {
//     if(error.hasOwnProperty('message')){
//         console.log(error.message)
//         return Promise.reject(error);
//     } else if (error.response.status === 401){
//         if(error.response.data.code == 20001){
//             router.push({path: 'login'})
//         }
//     }
//     return Promise.reject(error);
// })

MyCommons.MyAxios = {
	axiosInstance: axiosInstance,
	init: function(option = {}) {
		if (!option) {
			return;
		} else {
			if (option.baseUrl) {
				axiosInstance.baseUrl = option.baseUrl;
			}
			if (option.token) {
				axiosInstance.defaults.headers.common['Authorization'] = option.token;
			}
			if (option.username) {
				axiosInstance.defaults.headers.common['username'] = option.username;
			}
		}
	},
	post: function(url, params, isPayload = false, successCallBack, errorCallBack) {
		var initParams = new URLSearchParams();
		for (var key in params) {
			initParams.append(key, params[key]);
		}
		axiosInstance({
				method: 'post',
				url: url,
				data: isPayload ? params : initParams
			}).then(function(response) {
				// debugger
				// bridge(function(bridge) {
				// 	bridge.callHandler('handleOpenScoreResult', {data: '测试'});
				// }); 
				console.log(response)
				if (response && response.data && response.status == 200) {
					var data = response.data;
					if (typeof(data) == "object") {
						if (data && data.code == 1 || data.status == "Ok") {
							//成功
							successCallBack(data);
						} else {
							//失败
							errorCallBack(data.msg ? data.msg : data.data);
						}
					}
				}
			})
			.catch(function(error) {
				// debugger
				if (errorCallBack) {
					errorCallBack(error.response.data.message);
				}
			})
	},
	get: function(url, params, successCallBack, errorCallBack) {
		// debugger
		axiosInstance.get(url, params)
			.then(function(response) {
				if (response && response.data) {
					var data = response.data;
					// debugger
					if (typeof(data) == "object") {
						if (data && data.code == 1) {
							//成功
							successCallBack(data);
						} else {
							//失败
							errorCallBack(data.msg || data.message || data.data); //+data.data
						}
					}
				}
			})
			.catch(function(res) {
				// console.log(123,res.response)
				let msg = res.response ? (res.response.data.msg ? res.response.data.msg : res.response.data
					.data) : res.message;
				errorCallBack(msg || res.response.data.message);
			})
	},
	getText: function(url, params, successCallBack, errorCallBack) {
		// debugger
		axiosInstance.get(url, params)
			.then(function(response) {
				if (response.status == 200) {
					successCallBack(response.data)
				} else {
					errorCallBack(response.data)
				}
			})
			.catch(function(res) {
				errorCallBack(res);
				console.log(res);
			})
	},
	put: function(url, params, successCallBack, errorCallBack) {
		var initParams = new URLSearchParams();
		for (var key in params) {
			initParams.append(key, params[key]);
		}
		axiosInstance.put(url, params).then(function(response) {
			if (response && response.data) {
				var data = response.data;
				if (typeof(data) == "object") {
					if (data && data.code == 1) {
						//成功
						successCallBack(data);
					} else {
						//失败
						errorCallBack(data.msg + data.data);
					}
				}
			}
		}).catch(function(res) {
			if (errorCallBack) {
				errorCallBack(res.response.data.message);
			}
		});
	},
	delete: function(url, params, successCallBack, errorCallBack) {
		axiosInstance.delete(url, params)
			.then(function(response) {
				if (response && response.data) {
					var data = response.data;
					if (typeof(data) == "object") {
						if (data && data.code == 1) {
							//成功
							successCallBack(data);
						} else {
							//失败
							errorCallBack(data.msg);
						}
					}
				}
			})
			.catch(function(error) {
				if (errorCallBack) {
					errorCallBack(error.response.data.message);
				}
			})
	}
}
MyCommons.tools = {
	backToTop: function() {
		var gotoTop = function() {
			var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
			currentPosition -= 20;
			if (currentPosition > 0) {
				window.scrollTo(0, currentPosition);
			} else {
				window.scrollTo(0, 0);
				clearInterval(timer);
				timer = null;
			}
		}
		var timer = setInterval(gotoTop, 0.3);
	}
}

export default MyCommons;